import { useTranslation } from 'react-i18next';
import { DeltaLabel, AssetBaseInfo } from '@/shared/components';
import {
  useAppSettingsStore,
  formatReceivedAmount,
  formatReceivedPrice,
} from '@/shared/lib';
import type { ExchangeAsset } from '../model';

type Props = {
  type: 'from' | 'to';
  asset: ExchangeAsset;
  precision?: number;
};

const ExchangeAssetOption = ({ type, asset }: Props) => {
  const { t } = useTranslation();
  const { baseAsset } = useAppSettingsStore();

  const mainNumber =
    type === 'from'
      ? formatReceivedAmount(asset.available || 0)
      : formatReceivedPrice(asset.price || 0);
  const secondaryNumber = formatReceivedAmount(asset.baseAvailable || 0);

  return (
    <>
      <AssetBaseInfo asset={asset} className="grow" />
      <div className="flex flex-col items-end">
        <div className="headline4">
          {mainNumber}
          {type === 'to' && ' ' + baseAsset}
        </div>
        {type === 'from' && asset.baseAvailable !== 0 && (
          <div className="p5 text-secondary">
            {secondaryNumber} {baseAsset}
          </div>
        )}
        {type === 'to' && (
          <DeltaLabel
            deltaPercent={asset.deltaPercent}
            size="small"
            label={`(24${t('common.hoursShort')})`}
            className="bg-transparent p-0 p4"
          />
        )}
      </div>
    </>
  );
};

export { ExchangeAssetOption };
